// Week 4: Client Portal Foundation - Client Route Protection
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ClientRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return null; // or a loading spinner
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    // Only allow client users to access client portal
    if (user.role !== 'client') {
        return <Navigate to="/dashboard" />;
    }

    return children;
};

export default ClientRoute; 